/**
 * a generic function that wraps any potentially dangerous
 * io operation to make it safe, always returning an object
 * with data property and success flag. 
 * 
 * @param ioCallback async function that executes io operation 
 * @param logOnError if error should be sent to console (console.error)
 * @returns 
 */
export const safeIO = async <T>(
    ioCallback: () => Promise<T>,
    logOnError = false
) => {
    try {
        const data = await ioCallback()
        return {data, success: true}
    } catch (err) {
        if (logOnError) {
            console.error("io error", err)
        }
        return {data: null, success: false}
    }
}